import React, { Component, ErrorInfo, ReactNode } from 'react';
import { Heading, Content, Button } from "@react-spectrum/s2";
import i18n from '../../i18n';
interface ErrorBoundaryProps {
    children: ReactNode;
    fallback?: ReactNode;
    onReset?: () => void;
}
interface ErrorBoundaryState {
    hasError: boolean;
    error: Error | null;
}
export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps){
        super(props);
        this.state = {
            hasError: false,
            error: null
        };
    }
    static getDerivedStateFromError(error: Error): ErrorBoundaryState {
        return {
            hasError: true,
            error
        };
    }
    componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
        console.error('ErrorBoundary caught an error:', error, errorInfo);
    }
    handleReset = ()=>{
        this.setState({
            hasError: false,
            error: null
        });
        this.props.onReset?.();
    };
    render() {
        if (this.state.hasError) {
            if (this.props.fallback) {
                return this.props.fallback;
            }
            return (<div className={" Tk171 Qk171 Sk171 Rk171"}>
          <div className={" sd171 _ta171 eb171 Ul171 ql171"}>
            <Heading level={3}>{i18n.t('app.errorBoundary.title')}</Heading>
            <Content>
              {i18n.t('app.errorBoundary.body')}
            </Content>
            <Button variant="primary" onPress={this.handleReset}>
              {i18n.t('app.errorBoundary.button')}
            </Button>
          </div>
        </div>);
        }
        return this.props.children;
    }
}

import "macro-e67ea437b21703bf49bd8ed98ce85f2a5f6fef700f2e266811ec77a2f06c61d3.css";
import "macro-82beaf7387f55fd061bb2192d3751f3aa3bf90daad1eaaf095f3d421d19cab80.css";